import classNames from 'classnames';
import React from 'react';

export interface ModalFooterProps extends React.HTMLAttributes<HTMLElement> {
  tag?: React.ElementType;
  [key: string]: any;
}

const ModalFooter = ({ className, tag: Tag = 'div', ...attributes }: ModalFooterProps) => {
  return <Tag {...attributes} className={classNames(className, 'modal-footer')} />;
};

export default ModalFooter;
